import React from 'react';
import PropTypes from 'prop-types';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import AppInput from '../../../../common/AppInput';
import ProductPreview from '../../../../common/ProductPreview';
import Message from '../../../../common/Message';
import { INFO_DISPATCH_GOLD_SILVER } from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId } = props;

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };
  return (
    <React.Fragment>
      <MotiveTitle
        icon={textMapper.get(motiveId).icon}
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        mobile={mobile}
      />
      <ProductPreview mobile={mobile} />
      <Message
        severity="info"
        message={INFO_DISPATCH_GOLD_SILVER}
        fullRounded
      />
      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {!field.hidden && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
